import { transformExtent } from 'ol/proj';
import { Err, Ok } from 'ts-results';
export function TransformToWebExtent(sourceExtent, sourceProjection) {
    if (sourceProjection === 'EPSG:3857')
        return Ok(sourceExtent);
    try {
        const newExtent = transformExtent(sourceExtent, sourceProjection, 'EPSG:3857');
        return Ok(newExtent);
    }
    catch (e) {
        return Err(e);
    }
}
